import { Link, makeStyles } from '@material-ui/core';
import React, { useEffect, useState } from 'react'
import axios from "axios"
import { TrendingCoins } from '../../config/api';
import { CryptoState } from '../../CryptoContext';
import AliceCaurosel from "react-alice-carousel";



const useStyles = makeStyles(() => ({
  caurosel: {
    height: "50%",
    display: "flex",
    alignItems: "center",
  },
  cauroselItem : {
    display: "flex",
    flexDirection: "column",
    alignItems: "center",
    cursor: "pointer",
    textTransform: "uppercase",
    color: "white",
  },
}));

//NumberWith Commas function
 export function numberWithCommas(x) {
  return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
}


const Caurosel = () => {
  const classes = useStyles();
  const [trending, setTrending] = useState([]);

  const { currency , symbol } = CryptoState();

  const fetchTrendingCoins = async () => {
    const { data } = await axios.get(TrendingCoins(currency));
    setTrending(data);
  };


  //Whenever the Dom renders it's going to call that function.
  useEffect(() => {
    fetchTrendingCoins();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [currency]);


  // Items Object (All items come from trending Context)
  const items = trending.map((coin) => {
    let profit = coin?.price_change_percentage_24h >= 0;

    return (
      <Link className={classes.cauroselItem} to={`/coins/${coin.id}`}>
        <img
          src={coin?.image}
          alt={coin?.name}
          height="80"
          style={{ marginBottom: 10 }}
        />
        <span>
          {coin.symbol}
          &nbsp;
          <span
          style = {{
            color: profit > 0 ? "rgb(14, 203 ,129)" : "red",
            fontWeight: 500,
          }}
          
          >
            {profit && "+"} {coin?.price_change_percentage_24h?.toFixed(2)}%
          </span>
        </span>
        <span style={{ fontSize: 22, fontWeight: 500 }}>
          {symbol} {numberWithCommas(coin?.current_price.toFixed(2))}
        </span>
      </Link>
    );
  });

  // Responsive Object
  const responsive = {
    0: {
      items: 2,
    },
    512: {
      items: 4,
    },
  };

  return <div className={classes.caurosel}>
    <AliceCaurosel
    mouseTracking
    infinite
    autoPlayInterval={1000}
    animationDuration= {1500}
    disableButtonsControls
    disableDotsControls
    responsive={responsive}
    autoPlay
    items={items}

    
    />
  </div>;
};

export default Caurosel